import { Outlet, createFileRoute } from '@tanstack/react-router';

import { clientsSearchSchema } from '@/features/clients/hooks/use-clients-table-state';

// Layout de la sección /clients. La ruta `_app/clients` valida los search
// params con Zod (TanStack Router lo maneja nativo). El index renderiza la
// página principal.
export const Route = createFileRoute('/_app/clients')({
  validateSearch: (search) => clientsSearchSchema.parse(search),
  component: ClientsLayout,
});

function ClientsLayout() {
  return <Outlet />;
}
